import React from 'react';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';

const SocialMedia = () => (
  <div className="app__social">
    <div >
    <a
        href="https://www.linkedin.com/in/nyein-kalayar-kyaw/">
          <BsLinkedin />
    </a>
      
    </div>
    <div>
    <a
        href="https://mail.google.com/mail/u/0/#sent?compose=new">
          <MdEmail />
    </a> 
    </div>
    <div>
    <a
        href="https://github.com/BellaNyein">
          <BsGithub />
    </a>
    </div>
  </div>
);

export default SocialMedia;